import React from "react"
import {ErrorProps} from "@irati/ui/src/Loading"
import {getErrorValues} from "@irati/utils/lang/formatError"
import {injectIntl, InjectIntl} from "@irati/utils/lang"
import ErrorText from "@irati/ui/src/ErrorText"
import styled from "styled-components"
import getCodeFromError from "@irati/utils/services/API/helpers/getCodeFromError"
import {getRLOTErrorMessage} from "@irati/checkout/utils/basket/helper/getRLOTErrorMessage"

const StyledErrorWrapper = styled.div`
  margin: 5px 0 5px 0;
`

interface Props extends ErrorProps, InjectIntl {}

const RLOTError: React.FC<Props> = ({formatMessage, error, errorMsg}) => {
  const errorCode = getCodeFromError(error)
  const errorData = getErrorValues(error)
  const message = getRLOTErrorMessage(errorCode, errorMsg, errorData, formatMessage)
  return (
    <StyledErrorWrapper id="errorMessagesForLimitRedemptions">
      <ErrorText>{message}</ErrorText>
    </StyledErrorWrapper>
  )
}

export default injectIntl(RLOTError)
